module.exports = __webpack_public_path__ + "static/media/success(3).378102d5.png";